import { useCallback, useState } from 'react'

export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'psp.sidebar.collapsed'

export function getStoredSidebarCollapsed() {
  try {
    return window.localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

function storeSidebarCollapsed(collapsed: boolean) {
  try {
    window.localStorage.setItem(
      SIDEBAR_COLLAPSED_STORAGE_KEY,
      String(collapsed),
    )
  } catch {
    // Keep the in-memory state when storage is unavailable.
  }
}

export function useSidebarCollapsed() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    getStoredSidebarCollapsed,
  )

  const toggleSidebar = useCallback(() => {
    setSidebarCollapsed(previous => {
      const next = !previous
      storeSidebarCollapsed(next)
      return next
    })
  }, [])

  return { sidebarCollapsed, toggleSidebar }
}
